module.exports = __webpack_public_path__ + "static/media/mongodb.b392cbc3.png";